import "./PaymentProcedure.scss";
import "./PaymentProcedureMobile.scss";
import OrderInfo from "./Content/OrderInfo/OrderInfo";
import Payment from "./Content/Payment/Payment";
import UploadReciept from "./Content/UploadReciept/UploadReciept";
import DonePayment from "./Content/DonePayment/DonePayment";
import { BagIcon } from "../../../../../../Assets/Icons/bagIcon";
import { WalletIcon } from "../../../../../../Assets/Icons/WalletIcon";
import { ReceiptIcon } from "../../../../../../Assets/Icons/ReceiptIcon";
import { DoneIcon } from "../../../../../../Assets/Icons/DoneIcon";
import { useState, useEffect } from "react";

export default function PaymentProcedure({
  onClose,
  selectedOrders,
  setSelectedOrders,
  setOrderListUpdate,
  hasPartial,
}) {
  const [progress, setProgress] = useState(1);

  const fullbar = 70; // make it 100% for easier scaling
  const steps = fullbar / 3; // total steps
  const [progressWidth, setProgressWidth] = useState(fullbar);
  const [isCancelled, setIsCancelled] = useState(false);

  const [paymentType, setPaymentType] = useState("full"); // "full" | "partial"
  const [paymentMethod, setPaymentMethod] = useState("gcash");
  const [amountToPay, setAmountToPay] = useState(0);

  useEffect(() => {
    switch (progress) {
      case 1:
        setProgressWidth(fullbar);
        break;
      case 2:
        setProgressWidth(fullbar - steps * 1);
        break;
      case 3:
        setProgressWidth(fullbar - steps * 2);
        break;
      case 4:
        setProgressWidth(fullbar - steps * 3);
        break;
      case 5:
        onClose();
        break;
      default:
        setProgressWidth(fullbar);
        break;
    }
  }, [progress]);
  useEffect(() => {
    if (isCancelled) onClose();
  }, [isCancelled]);

  const modalCotent = [OrderInfo, Payment, UploadReciept, DonePayment];
  const ActiveComponent = modalCotent[progress - 1]; // get the component
  return (
    <div className="Procedure-container">
      <div className="header">
        <div className="progressbarback"></div>
        <div
          className="progressbar"
          style={{ width: `${progressWidth}%` }}
        ></div>

        {/* Step 1 */}
        <button>
          <div
            style={{
              background: progress >= 1 ? "black" : "",
            }}
          >
            <BagIcon
              fillColor={progress >= 1 ? "black" : ""}
              strokeColor={progress >= 1 ? "white" : ""}
            />
          </div>
          <span>ORDER INFORMATION</span>
        </button>

        {/* Step 2 */}
        <button>
          <div
            style={{
              transitionDelay: "0.3s",
              background: progress >= 2 ? "black" : "",
            }}
          >
            <WalletIcon
              fillColor={progress >= 2 ? "black" : "#cbcbcb"}
              strokeColor={progress >= 2 ? "white" : ""}
            />
          </div>
          <span>PAYMENT</span>
        </button>

        {/* Step 3 */}
        <button>
          <div
            style={{
              transitionDelay: "0.3s",
              background: progress >= 3 ? "black" : "",
            }}
          >
            <ReceiptIcon
              fillColor={progress >= 3 ? "black" : "#cbcbcb"}
              strokeColor={progress >= 3 ? "white" : ""}
            />
          </div>
          <span>UPLOAD RECEIPT</span>
        </button>

        {/* Step 4 */}
        <button>
          <div
            style={{
              transitionDelay: "0.3s",
              background: progress >= 4 ? "black" : "",
            }}
          >
            <DoneIcon
              style={{
                transitionDelay: "0.3s",
              }}
              fillColor={progress >= 4 ? "black" : "#cbcbcb"}
              strokeColor={progress >= 4 ? "white" : ""}
              size={32}
            />
          </div>
          <span>DONE</span>
        </button>
      </div>

      <div className="body">
        <ActiveComponent
          setProgress={setProgress}
          progress={progress}
          setIsCancelled={setIsCancelled}
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
          setPaymentType={setPaymentType}
          paymentType={paymentType}
          setPaymentMethod={setPaymentMethod}
          paymentMethod={paymentMethod}
          setAmountToPay={setAmountToPay}
          amountToPay={amountToPay}
          setOrderListUpdate={setOrderListUpdate}
          onClose={onClose}
          hasPartial={hasPartial}
        />
      </div>
    </div>
  );
}
